import classNames from 'classnames';
import { format } from 'date-fns';
import { ref, remove, update } from 'firebase/database';
import { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { AttachModal } from './AttachModal';
import { getStudentView, createNotebooksFunc, getTeacherScheduleBoard, getTeachers } from '../../Common/Database';
import { database } from '../../Common/Firebase';
import EditStudentModal from '../../Components/EditStudentModal';
import Loader from '../../Components/Loader';
import Tooltipe from '../../Components/Tooltipe';
import { throwErrorRollbar } from '../../index';
import { getUserType } from '../../redux/slices/userSlice';

import './style.scss';

const StudentView = ({ mail }) => {
  const { t, i18n } = useTranslation();
  const params = useParams();

  const location = useLocation();
  const navigate = useNavigate();
  const userTypeSelector = useSelector(getUserType);

  const [student, setStudent] = useState();
  const [subjectList, setSubjectList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [addSubject, setAddSubject] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [editStudent, setEditStudent] = useState(true);
  const [userType, setUserType] = useState(userTypeSelector);
  const [openTeacherAttachModal, setOpenTeacherAttachModal] = useState(false);
  const [listTeachers, setListTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [curentSubject, setCurentSubject] = useState();
  const [itemTeacher, setItemTeacher] = useState('');
  const [fioStudent, setFioStudent] = useState('');

  const admins = userType === 'NewAdmin' || userType === 'Admin' || userType === 'Superadmin';

  const teacher = userType === 'Teacher';

  const canAttachedTeachersToStudents = admins || teacher;

  useEffect(() => {
    if (location && location.state && location.state.fio) {
      setFioStudent(location.state.fio);
    }
  }, [location]);

  const fetchStudentView = async () => {
    try {
      await getStudentView(params.id).then(response => {
        const resp = response?.val();

        if (resp) {
          const stSubjects = Object.values(resp.subjects);

          setStudent(resp);
          setSubjectList(stSubjects);
          setIsLoading(false);
        } else {
          console.log('STUDENT NOT FOUND BY ID:', params.id);
        }
      });
    } catch (error) {
      console.error('Error fetching schedule:', error);
    }
  };

  const feachTeacher = async () => {
    await getTeachers().then(response => {
      const arrTeachers = Object.values(response);
      setListTeachers(arrTeachers);
      setIsLoading(false);
    });
  };

  const openModalUpdateStudent = async () => {
    setOpenModal(true);
    await getStudentView(params.id).then(response => {
      const resp = response.val();
      setStudent(resp);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    setUserType(userTypeSelector);
    fetchStudentView();

    if (canAttachedTeachersToStudents) {
      feachTeacher();
    }
  }, [addSubject, userTypeSelector, userType, curentSubject, selectedTeacher]);

  useEffect(() => {
    const table = document.getElementById('student-subjects');
    if (table) {
      const tbody = table.querySelector('tbody');
      if (tbody) {
        const rows = tbody.getElementsByTagName('tr');
        for (let i = 0; i < rows.length; i++) {
          const cells = rows[i].getElementsByTagName('td');
          let allEmpty = true;
          for (let j = 0; j < cells.length; j++) {
            if (cells[j].innerText.trim() !== '') {
              allEmpty = false;
              break;
            }
          }
          rows[i].style.display = allEmpty ? 'none' : '';
        }
      }
    }
  });

  const columns = canAttachedTeachersToStudents
    ? [
        {
          dataField: 'name',
          text: t('subjects'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('subject') },
          formatter: cell => t(cell),
        },
        {
          dataField: 'attachedTeacher.FIO',
          text: t('Responsible teacher'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('Responsible teacher') },
          formatter: cell => {
            return cell ? cell : '-';
          },
        },
        {
          dataField: 'activeSub',
          text: t('subject activation'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('activation') },
          formatter: dataField => {
            const buttonStyles = {
              background: dataField ? '#f2e6ed' : '#9cdffc',
            };

            return (
              <button id={String(dataField)} style={buttonStyles} className="btn btn-primary more btn-active">
                {dataField ? t('delete') : t('add')}
              </button>
            );
          },
        },
        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          formatter: (dataField, row) => {
            return (
              <div className="actions-wrap">
                <div className="flex items-center justify-between">
                  {row.attachedTeacher ? (
                    <Tooltipe text="edit a teacher" icon="icon-checked-icon" btnClass="attach-teacher" />
                  ) : (
                    <Tooltipe text="appoint a teacher" icon="icon-plus1" btnClass="attach-teacher" />
                  )}
                  <Tooltipe text="schedule" icon="icon-schedule" btnClass="move-schedule" />
                </div>
              </div>
            );
          },
        },
      ]
    : [
        {
          dataField: 'name',
          text: t('subjects'),
          disableClickEventBubbling: true,
          attrs: { 'data-label': t('name') },
          formatter: (cell, row) => {
            if (row.attachedTeacher && row.attachedTeacher.id === mail) {
              return t(cell);
            }
          },
        },

        {
          dataField: 'id',
          text: <div className="sticky-wrap">{t('options')}</div>,
          attrs: { 'data-label': t('options') },
          formatter: (dataField, row) => {
            if (row.attachedTeacher && row.attachedTeacher.id === mail) {
              return (
                <div className="actions-wrap">
                  <Tooltipe text="schedule" icon="icon-schedule" btnClass="move-schedule" />
                </div>
              );
            }
          },
        },
      ];

  const rowEvents = {
    onClick: async (e, row) => {
      if (e.target.className === 'btn btn-primary more btn-active') {
        try {
          const now = new Date();
          const formattedTime = format(now, 'dd MM yyyy HH:mm');
          const subjectName = row.name;
          const notificationData = {
            id: params.id,
            idItem: subjectName,
            name: subjectName,
            subject: subjectName,
            time: formattedTime,
            subType: 'add-subject',
            viewed: true,
          };

          if (row.activeSub) {
            notificationData.type = 'subjects-remove';
          } else {
            notificationData.type = 'subjects';
          }

          await update(ref(database, `Students/${params.id}/subjects/${subjectName}`), {
            activeSub: !row.activeSub,
            getNotebook: true,
            schedule: !row.activeSub,
            attachedTeacher: {},
          });

          await update(ref(database, `Students/${params.id}/notification`), {
            [subjectName + params.id + uuidv4()]: notificationData,
          });

          try {
            const response = await getTeacherScheduleBoard(mail);
            const resp = response.val();

            if (resp && typeof resp === 'object') {
              let stSchedule = Object.values(resp);

              for (const items of stSchedule) {
                let itemsMap = Object.values(items);
                for (const filterItem of itemsMap) {
                  if (filterItem.student === student.FIO) {
                    await remove(ref(database, `Teachers/${mail}/schedule/${subjectName}/${filterItem.id}`));
                  }
                }
              }
            }
          } catch (error) {
            console.error('Error fetching schedule:', error);
          }

          setSubjectList();
          setAddSubject(prev => !prev);
        } catch (error) {
          console.log(error);
          throwErrorRollbar(error);
        }

        if (!row.getNotebook) {
          createNotebooksFunc(params.id, row.name);
        }
      }

      if (e.target.className === 'btn btn-icon attach-teacher') {
        setOpenTeacherAttachModal(true);
        setCurentSubject(row);

        if (!row.getNotebook) {
          createNotebooksFunc(params.id, row.name);
        }
      }

      if (e.target.className === 'btn btn-icon move-schedule') {
        sessionStorage.setItem('StudentView', JSON.stringify(row));
        navigate(`/schedule/${params.id}/subjects/${row.name}`);
      }

      if (e.target.className === 'btn btn-icon btn-action-menu') {
        setOpenDrops(prev => ({
          ...prev,
          [row.name]: !prev[row.name],
        }));
      }
    },

    // formatExtraData: openDrops,
  };

  const onAttachStudent = async () => {
    try {
      const now = new Date();
      const formattedTime = format(now, 'dd MM yyyy HH:mm');
      const subjectName = curentSubject.name;

      await update(ref(database, `Students/${params.id}/subjects/${subjectName}`), {
        activeSub: true,
        getNotebook: true,
        attachedTeacher: {
          id: itemTeacher.email.replace(/\./g, ''),
          FIO: itemTeacher.FIO,
          firstName: itemTeacher.firstName,
          lastName: itemTeacher.lastName,
          patronymic: itemTeacher.patronymic,
        },
        schedule: true,
      });

      await update(ref(database, `Students/${params.id}/notification`), {
        ['attachedTeacher' + itemTeacher.email.replace(/\./g, '') + subjectName]: {
          id: itemTeacher.email.replace(/\./g, '') + subjectName,
          idItem: subjectName,
          name: itemTeacher.FIO,
          subject: subjectName,
          time: formattedTime,
          type: 'subjects add-teacher',
          subType: 'add-subject',
          viewed: true,
        },
      });

      await update(ref(database, `Teachers/${itemTeacher.email.replace(/\./g, '')}/notification`), {
        ['attachedTeacheradd-student' + params.id + subjectName]: {
          id: params.id + subjectName,
          idItem: subjectName,
          name: fioStudent ? fioStudent : fioStudent,
          subject: subjectName,
          time: formattedTime,
          type: 'subjects add-student',
          subType: 'add-student',
          viewed: true,
          studentMail: params.id,
        },
      });
    } catch (error) {
      console.error('Error fetching teacher info', error);
    }

    setOpenTeacherAttachModal(false);
    fetchStudentView();
  };

  const onTeacherChange = selectedTeacher => {
    const filterData = listTeachers.filter(item => {
      if (selectedTeacher == item.FIO) {
        return item;
      }
    });
    setSelectedTeacher(selectedTeacher);
    setItemTeacher(filterData[0]);
  };

  return (
    <div className="student-view-page container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="list-wrap student-wrap">
            <h2>
              {t('studentData')}:
              {canAttachedTeachersToStudents && (
                <Tooltipe method={openModalUpdateStudent} text="update" icon="icon-edit-1" btnClass="move-view" />
              )}
            </h2>

            {student && (
              <ul className="studetn-data-list">
                <li>
                  <span className="key">{t('fio')}: </span>
                  <span className="value">{student && student.FIO}</span>
                </li>
                <li>
                  <span className="key">{t('email')}: </span>
                  <span className="value">{student.email}</span>
                </li>
                <li>
                  <span className="key">{t('age')}: </span>
                  <span className="value">{student.age ? student.age : '-'}</span>
                </li>
                <li>
                  <span className="key">{t('class')}: </span>
                  <span className="value">{student.classStudent ? student.classStudent : '-'}</span>
                </li>
                <li>
                  <span className="key">{t('city')}: </span>
                  <span className="value">{student.city ? student.city : '-'}</span>
                </li>
                <li>
                  <span className="key">{t('branch')}: </span>
                  <span className="value">{student.branch ? student.branch : '-'}</span>
                </li>
              </ul>
            )}
          </div>
          <div className="list-wrap subjects-wrap students-page">
            <h2>{t('subjects')}:</h2>

            {subjectList ? (
              <ToolkitProvider key={i18n.language} keyField="name" data={subjectList} columns={columns}>
                {props => (
                  <div>
                    <div className="materials-table">
                      <BootstrapTable {...props.baseProps} rowEvents={rowEvents} id="student-subjects" />
                    </div>
                  </div>
                )}
              </ToolkitProvider>
            ) : (
              <></>
            )}

            {openModal && (
              <EditStudentModal
                open={openModal}
                setOpen={setOpenModal}
                submit={t('update')}
                nameAction={'createForm'}
                updateFormObj={''}
                student={student}
                editStudent={editStudent}
                fetchStudentView={fetchStudentView}
              />
            )}

            {openTeacherAttachModal && (
              <AttachModal
                setOpenTeacherAttachModal={setOpenTeacherAttachModal}
                selectedTeacher={selectedTeacher}
                onTeacherChange={onTeacherChange}
                listTeachers={listTeachers}
                onAttachStudent={onAttachStudent}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default StudentView;
